import React, { useEffect, useState } from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import { debugLog } from '../utils/debugUtils';

/**
 * InlineWebAd - Displays an inline AdSense ad for web platforms
 *
 * This component shows an AdSense ad unit inline within the page layout,
 * designed to be placed below other content elements.
 */
const InlineWebAd = ({ adClientId, adSlot }) => {
    const [adLoaded, setAdLoaded] = useState(false);

    useEffect(() => {
        // Load AdSense ad with a small delay to ensure the DOM is ready
        const loadAd = () => {
            try {
                debugLog('Attempting to load inline AdSense ad...');
                debugLog('AdClient ID:', adClientId);
                debugLog('AdSlot ID:', adSlot);

                // Check if adsbygoogle is available
                if (typeof window !== 'undefined' && window.adsbygoogle) {
                    const adElements = document.querySelectorAll('.adsbygoogle');
                    debugLog('Found ad elements:', adElements.length);

                    // Push ad to AdSense queue
                    try {
                        (window.adsbygoogle = window.adsbygoogle || []).push({});
                        debugLog('Inline AdSense ad pushed to queue');
                        setAdLoaded(true);
                    } catch (e) {
                        console.error('Error pushing inline ad to queue:', e);
                    }
                } else {
                    console.warn('AdSense script not loaded yet');
                }
            } catch (error) {
                console.error('Error loading inline AdSense ad:', error);
            }
        };

        // Load ad after a small delay to ensure DOM is ready
        const adLoadTimeout = setTimeout(loadAd, 100);

        return () => {
            clearTimeout(adLoadTimeout);
        };
    }, [adClientId, adSlot]);

    if (!adClientId || !adSlot) {
        return null;
    }

    return (
        <Card elevation={3} sx={{ width: '100%' }}>
            <CardContent sx={{
                p: 1.5,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                bgcolor: '#f5f5f5',
                '&:last-child': { pb: 1.5 }
            }}>
                <Typography variant="caption" color="text.secondary" sx={{ mb: 1 }}>
                    Publicidad
                </Typography>
                <Box
                    sx={{
                        width: '100%',
                        minHeight: '90px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <ins
                        className="adsbygoogle"
                        style={{
                            display: 'block',
                            width: '100%',
                            minHeight: '90px'
                        }}
                        data-ad-client={adClientId}
                        data-ad-slot={adSlot}
                        data-ad-format="horizontal"
                        data-full-width-responsive="true"
                    />
                </Box>
            </CardContent>
        </Card>
    );
};

export default InlineWebAd;
